export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    location: 'Banjara Hills, Hyderabad',
    rating: 5,
    orderType: 'Bouquet',
    text: 'The lilies arrived fresh and in full bloom — exactly as described. The fragrance filled my entire home! They were perfectly cut and ready for a beautiful vase. Will definitely order again!',
    date: 'March 2026'
  },
  {
    id: 2,
    name: 'Rajesh Reddy',
    location: 'Jubilee Hills, Hyderabad',
    rating: 5,
    orderType: 'Bulk Order',
    text: 'Ordered 40 stems for my daughter\'s engagement. The A-grade quality was evident — pristine petals, gorgeous aroma, and they lasted over a week. Delivered within 24 hours as promised. Exceptional service!',
    date: 'February 2026'
  },
  {
    id: 3,
    name: 'Kavita Desai',
    location: 'Gachibowli, Hyderabad',
    rating: 5,
    orderType: 'Weekly Subscription',
    text: 'I have been on the weekly subscription for two months now. Every delivery is consistently fresh, beautifully fragrant, and looks stunning in my living room vase. The premium quality is worth every rupee!',
    date: 'March 2026'
  },
  {
    id: 4,
    name: 'Arjun Mehta',
    location: 'Hitech City, Hyderabad',
    rating: 5,
    orderType: 'Single Bouquet',
    text: 'Surprised my wife with the Stargazer bouquet for our dinner party. The beautiful aroma filled the room and they were perfectly cut, ready for a beautiful evening. A-grade quality, arrived same day!',
    date: 'March 2026'
  },
  {
    id: 5,
    name: 'Meera Iyer',
    location: 'Madhapur, Hyderabad',
    rating: 5,
    orderType: 'Bouquet',
    text: 'Simply the best lilies in Hyderabad. Farm-fresh, A-grade blooms that lasted nearly 10 days. The stems were perfectly cut and arrangement-ready. The elegance they brought to my home office is unmatched!',
    date: 'February 2026'
  }
];
